<template>
  <section id="home" class="section intro">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-lg-6">
        <div class="box-info-intro">
          <div class="box-img">
            <img src="images/m1.jpg" loading="lazy">
          </div>
          <h1>Welcome</h1>
          <VueWriter
              :array="arr_text"
              :start="100"
              :eraseSpeed="25" :typeSpeed="50" :delay="500"
              :caret="'cursor'"
          ></VueWriter>
          <a class="btn btn-outline-primary"  href="cv/CV_Mohammad_Ali.pdf">Download CV <i class="fa-solid fa-file-download ms-2 me-2"></i></a>
        </div>
      </div>
      <div class="col-12 col-lg-6">
        <div id="globe-container"></div>
      </div>
    </div>
  </div>
  </section>
</template>

<script>
import { World } from "@/world/world";
import VueWriter from 'vue-writer'
export default {
  name: "VueGlobeClone",
  data(){
    return{
      arr_text:["I'm Mohammad Ali","I'm information technology engineer","I'm a software engineer"]
    }
  },
  components: {
    VueWriter,
  },
  mounted() {
    const container = document.querySelector("#globe-container");
    const world = new World(container);
    world.start();
  }
}
</script>

<style scoped>
.intro{
  min-height: 100vh;
}
.box-info-intro{
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 20px;
  padding: 50px 25px 25px;
}
.box-img{
  width: 200px;
  height: 200px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-bg1);
  box-shadow:inset 2px 2px 5px rgba(255,255,255,0.15),
  inset 0 -2px 5px rgba(0,0,0,0.5);
}
.box-img img{
  width: 175px;
  height: 175px;
  border-radius: 50%;
}
#globe-container{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>